
window.estatePromotion = {
  handler: {}
};

estatePromotion.ready = function() {
  const preview = document.getElementById('preview-enriched-message');
  const fields = [
    { name: 'estate_name',  placeholder: '{{estate_name}}',  regex: /{{\s*estate_name\s*}}/g },
    { name: 'price',        placeholder: '{{price}}',        regex: /{{\s*price\s*}}/g },
    { name: 'property_url', placeholder: '{{property_url}}', regex: /{{\s*property_url\s*}}/g }
  ];

  function getFieldValue(field) {
    const el = document.querySelector(`input[name="${field.name}"]`);
    return el ? el.value : '';
  }

  function handleInput() {
    if (!preview) return;
    let content = preview.dataset.template;
    fields.forEach(field => {
      const value = getFieldValue(field) || field.placeholder;
      content = content.replace(field.regex, value);
    });
    preview.textContent = content;
  }

  function init() {
    console.log("[New] Initializing estate promotion handler");
    fields.forEach(field => {
      const el = document.querySelector(`input[name="${field.name}"]`);
      if (el) el.addEventListener('input', handleInput);
    });
    if (preview && !preview.dataset.template) {
      preview.dataset.template = preview.textContent;
    }
  }

  estatePromotion.handler = { handleInput, init };
  estatePromotion.handler.init();
};
